import React, { FC } from "react";
import { IPost } from "../config/interface";

type Props = { post: IPost };

const PostListItem: FC<Props> = ({ post }: Props) => {
  return (
    <div className="row align-items-center mx-0 bf-library-search-result border-top py-2">
      <div className="col px-2 bf-library-search-result-title fs-2">
        <a href={`${post.link}`} target="_blank" rel="noreferrer">
            <span dangerouslySetInnerHTML={{__html: post.title.rendered}}></span>
        </a>
      </div>
      <div className="col-auto pl-2 pe-0 bf-library-search-result-btn">
        <a
          className="btn btn-icon btn-icon-right"
          href={`${post.link}`}
          target="_blank"
          rel="noreferrer"
        >
          Download<i className="material-symbols-outlined">download</i>
        </a>
      </div>
    </div>
  );
};

export default PostListItem;
